/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stack_Heading_LabelInputs */

const en_stack_heading_label = /** @type {(inputs: Stack_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Goto Stack`)
};

const ar_stack_heading_label = /** @type {(inputs: Stack_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حزمة تقنياتي المفضلة`)
};

const bn_stack_heading_label = /** @type {(inputs: Stack_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমার গো-টু স্ট্যাক`)
};

const de_stack_heading_label = /** @type {(inputs: Stack_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mein bevorzugter Stack`)
};

const es_stack_heading_label = /** @type {(inputs: Stack_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi stack favorito`)
};

const fr_stack_heading_label = /** @type {(inputs: Stack_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma stack préférée`)
};

const pt_stack_heading_label = /** @type {(inputs: Stack_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minha stack principal`)
};

const zh_stack_heading_label = /** @type {(inputs: Stack_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的转到堆栈`)
};

const tr_stack_heading_label = /** @type {(inputs: Stack_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goto Yığınım`)
};

const ru_stack_heading_label = /** @type {(inputs: Stack_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мой стек переходов`)
};

const pl_stack_heading_label = /** @type {(inputs: Stack_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mój stos Goto`)
};

/**
* | output |
* | --- |
* | "My Goto Stack" |
*
* @param {Stack_Heading_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const stack_heading_label = /** @type {((inputs?: Stack_Heading_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stack_Heading_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_stack_heading_label(inputs)
	if (locale === "bn") return bn_stack_heading_label(inputs)
	if (locale === "de") return de_stack_heading_label(inputs)
	if (locale === "es") return es_stack_heading_label(inputs)
	if (locale === "fr") return fr_stack_heading_label(inputs)
	if (locale === "pt") return pt_stack_heading_label(inputs)
	if (locale === "zh") return zh_stack_heading_label(inputs)
	if (locale === "tr") return tr_stack_heading_label(inputs)
	if (locale === "ru") return ru_stack_heading_label(inputs)
	if (locale === "pl") return pl_stack_heading_label(inputs)
	return en_stack_heading_label(inputs)
});